module.exports = __webpack_public_path__ + "static/img/img_intro.f6c8665.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img_intro.jpg
// module id = igKk
// module chunks = 0